(function(){
  'use strict';
  var me=document.currentScript;
  var src=me&&me.src?me.src:'';
  var base=src.replace(/bo-baby-shower\.js(?:\?.*)?$/,'');
  var files=['bo-baby-shower-v6-p1.js','bo-baby-shower-v6-p2.js','bo-baby-shower-v6-p3.js','bo-baby-shower-v6-p4.js','bo-baby-shower-v6-p5.js','bo-baby-shower-v6-p6.js','bo-baby-shower-v6-p7.js','bo-baby-shower-v6-p8.js','bo-baby-shower-v7-addon.js','bo-baby-shower-v8-fixes.js'];
  var i=0;
  function next(){
    if(i>=files.length)return;
    var s=document.createElement('script');
    s.src=base+files[i++];
    s.async=false;
    s.onload=next;
    s.onerror=function(){console.error('Baby Shower: no se pudo cargar '+s.src);};
    document.head.appendChild(s);
  }
  next();
})();
